// Centralised social / external links so they're only configured in one place.
export const TELEGRAM_URL = "https://t.me/vtstradingbott";
export const TELEGRAM_HANDLE = "@vtstradingbott";

export const DERIV_AFFILIATE_URL =
  "https://t.deriv.link/?t=DX49FZV263DV";

export const DERIV_API_TOKEN_URL =
  "https://app.deriv.com/account/api-token";
